<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "IntelligentTranslation",
  data () {
    return {};
  },
};
</script>
<style lang="less" scoped>
</style>
